const matchers = require('./matchers');
const _ = require('lodash')
module.exports = (angularModule) => {
  angularModule.controller('adviceLocalBackSyncCtrl',
    (
      $scope,
      $http,
      $location,
      userService,
      confirmService
    ) => {

      $scope.matchers = matchers;
      $scope.matchersIndex = {};
      $scope.matchers.forEach(x => $scope.matchersIndex[x.id] = x);
      $scope.isSubmitted = false;
      $scope.isSubmitComplete = false;
      $scope.errorMessages = [];
      $scope.selectedMatcher = $scope.matchers[0];


      function resetArgs() {
        $scope.args = {
          accountId: undefined,
          includeSubAccounts: false,
          dryRun: true,
          relink: false,
          keys: '',
          emailReportRecipients: '',
          matchers: [{
            matcherName: 'UniquePhone', args: {}
          }, {
            matcherName: 'MatchAlgo', args: { minMatch: 7 }
          }, {
            matcherName: 'ExactNameAndAddress', args: {}
          }]
        }
      }

      $scope.getAccountSelectProps = () => ({
        value: $scope.args.accountId,
        autoload: false,
        loadOptions: (input, cb) => {
          $http.get('/manageTool/accounts', {params: {q: input}})
            .then(resp => {
              let mapped = resp.data.map(x => ({label: `${x.name} (${x.billingAccountName})`, value: x.accountId}));
              cb(mapped)
            })
        },
        onChange: (opt) => {
          $scope.args.accountId = opt;
        }
      });



      const dataParam = $location.search().data;
      if (dataParam) {
        try {
          $scope.args = JSON.parse(dataParam)
        } catch (e) {
          resetArgs()
        }
      } else {
        resetArgs();
      }

      $scope.addMatcher = () => {
        $scope.args.matchers.push({
          matcherName: $scope.selectedMatcher.id, args: {...$scope.selectedMatcher.defaultArgs}
        })
      }
      $scope.removeMatcherIdx = (idx) => {
        $scope.args.matchers.splice(idx, 1)
      }

      const split = str => (str || '').split(',').map(x => x.trim()).filter(x => x.length)

      function associationStringToMap(x = '') {
        const ans = {};
        const entries = x.split(',').map(x => x.trim()).filter(x => x.length)
        for (let e of entries) {
          const tuple = e.split('->').map(x => x.trim()).filter(x => x.length)
          if (tuple.length > 1) {
            ans[tuple[0]] = tuple[1]
          }
        }
        return ans
      }

      const parseArgs = (args) => {
        return {
          ...args,
          accountId: args.accountId && args.accountId.value,
          emailReportRecipients: split(args.emailReportRecipients),
          keys: split(args.keys),
          matchers: args.matchers.map(x => {
            if (x.matcherName === 'Predefined') {
              return {
                ...x,
                args: {
                  ...x.args,
                  locationIdToClientId: associationStringToMap(x.args.locationIdToClientId)
                }
              }
            } else return x
          })
        }
      }

      const invalidReasons = args => {
        return [].concat(
          args.accountId ? [] : ['Must select an account']
        ).concat(
          args.keys.length ? [] : ['At least one API key must be specified']
        ).concat(
          args.matchers.length ? [] : ['At least one matcher must be specified']
        )
      }

      $scope.deleteExtraClients = function () {
        if (!$scope.summary || !$scope.summary.unmatchedClients) return
        confirmService.confirm(
          'Delete ' + $scope.summary.unmatchedClients + ' Clients from Advice Local?',
          'You cannot undo this action',
          confirmService.DELETE
        ).then(x => {
          if (x) {
            $scope.summary.deletingUnmatchedClients = true;
            $http
              .delete('/adviceLocalSync/log/' + $scope.summary.logId + '/unmatchedClients')
              .then(x => {
                $scope.summary.deletingUnmatchedClients = false
                if (x.data.problems.length) {
                  console.log("failed to sync some ids", x.data.problems)
                  window.alert('some clients failed to delete: ' + x.data.problems.join(', '))
                } else {
                  $scope.summary.deletedUnmatchedClients = true;
                }
              })
          }
        })
      }

      $scope.submitForm = () => {
        const args = parseArgs($scope.args);
        $scope.errorMessages = invalidReasons(args);
        if ($scope.errorMessages.length) return;
        else {
          $scope.isSubmitted = true;
          $scope.isSubmitComplete = false;
          $scope.lastError = undefined;
          $scope.summary = undefined;
          $http.post('/adviceLocalSync/run', args)
            .then(x => {
              $scope.isSubmitComplete = true;
              $scope.summary = x.data;
            })
            .catch(x => {
              $scope.isSubmitted = false
              $scope.lastError = x.data
              console.error(x)
            })
        }

      }

      $scope.$watch('args', () => {
        $location.search('data', JSON.stringify($scope.args));
      }, true)

    })
}
